import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import swal from "sweetalert";

import { useHistory } from "react-router-dom";

import {
  getTemplatesApiHandler,
  createCustTemplateApiHandler,
  deleteGroupingTemplateApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

import { Button } from "../../elements/Button";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchPri.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/infoGrey.svg";
import { ReactComponent as PlusIcon } from "../../assets/icons/whitePlus.svg";
import { ReactComponent as MyFinIcon } from "../../assets/icons/myFinCardIcon.svg";
import { ReactComponent as MenuDotIcon } from "../../assets/icons/menuDotBlack.svg";
import Breadcrumb from "../../components/Breadcrumb";
import Sidebar from "../../elements/Sidebar";
import bookclosuretablecss from "../../css/bookclosuretable.module.css";
import tablecss from "../../css/table.module.css";
import libcss from "../../css/library.module.css";

import CustomTemplateModal from "../../components/templateLibrary/CustomTemplateModal";

const StandaloneLibrary = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [fs, setFs] = useState([]);
  const [libraryName, setLibraryName] = useState("Library");
  const [defaultLibraryList, setDefaultLibraryList] = useState([]);
  const [customLibraryList, setCustomLibraryList] = useState([]);
  const [edit, setEdit] = useState(false);
  const [createCustomTemplateModal, setCreateCustomTemplateModal] =
    useState(false);

  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRef = useRef(null);

  const breadcrumbItems = [
    {
      label: "Template Library",
      link: `/preview`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: `${libraryName}`, link: "", className: "headerLable" },
  ];

  useEffect(() => {
    getTemplates();
  }, []);
  const getTemplates = () => {
    getTemplatesApiHandler({ sortField: "createdAt", sortOrder: "desc" })
      .then((response) => {
        if (response?.data?.success === true) {
          var templatesResp = response?.data?.groupingTemplateArray;
          templatesResp.forEach((obj) => {
            if (obj.templateType === "default") {
              setDefaultLibraryList((prev) => [...prev, obj]);
            }
            if (obj.templateType === "custom") {
              setCustomLibraryList((prev) => [...prev, obj]);
            }
          });
        }
      })
      .catch((error) => {
        // setCompanyData({});
      });
  };

  const createCustTemplate = (payload) => {
    createCustTemplateApiHandler(payload)
      .then((response) => {
        console.log("response", response);
        if (response?.data?.success === true) {
          swal("Custom template created successfully", "", "success");
          setDefaultLibraryList([]);
          setCustomLibraryList([]);
          getTemplates();
          setCreateCustomTemplateModal(false);
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to create custom template",
            "error"
          );
        }

        // setCommentsList(response.data.comments.reverse());
        // setAddCommentModal(false);
        // setTaskComment('');
        // toast.success("Comment posted successfully.");
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to create custom template",
          "error"
        );
      });
  };

  // Close on outside click
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
    };

    if (openMenuId) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openMenuId]);

  const deleteGroupingTemplate = (tempId) => {
    swal({
      title: "Confirm deletion of custom template",
      text: "Once deleted, you will not be able to recover this!",
      icon: "warning",
      buttons: {
        cancel: "Cancel",
        confirm: {
          text: "Delete",
          value: true,
          visible: true,
          className: "swal-delete-btn",
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteGroupingTemplateApiHandler({ groupingTemplateID: tempId })
          .then((response) => {
            if (response?.data?.success === true) {
              var templatesResp = response?.data?.groupingTemplateArray;
              templatesResp.forEach((obj) => {
                if (obj.templateType === "default") {
                  setDefaultLibraryList((prev) => [...prev, obj]);
                }
                if (obj.templateType === "custom") {
                  setCustomLibraryList((prev) => [...prev, obj]);
                }
              });
            }
          })
          .catch((error) => {
            swal(
              "Error",
              error?.response?.data?.error ||
                "Error in deleting grouping template",
              "error"
            );
          });
      }
    });
  };

  return (
    <>
      <div>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className={commoncss.w100}
            style={{ maxHeight: "100vh", overflowY: "hidden" }}
          >
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={commoncss.w100}
              style={{ maxHeight: "95vh", overflowY: "hidden" }}
            >
              <header className={`connections-header ${commoncss.greyBg}`}>
                <span className="header-title">Template Library</span>
                <div className="button-group"></div>
                <div className="header-actions">
                 <div style={{ marginRight: "14px" }} >
                  <SearchIcon />
                </div>

                <div style={{ marginRight: "8px" }}>
                  <FilterIcon />
                </div>
                  <Button
                    icon={<PlusIcon width={18} height={18} />}
                    btnColor={buttoncss.primary}
                    label={"Custom Template"}
                    onClick={() => setCreateCustomTemplateModal(true)}
                  />
                </div>
              </header>
            </motion.div>

            <div className={`${libcss.libHomeBody}`}>
              <div className="mt-3">
                <span
                  className={`${commoncss.labelBlack} ${commoncss.fs19} ml-4`}
                >
                  MyFinalyst Templates (Default)
                </span>
                <motion.div
                  initial={{ y: 100, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 0, opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  className="modulecards-grid"
                >
                  {/* {[...Array(4)].map((_, i) => (
                    <div
                      className={`${libcss.libCard} clickable`}
                      style={{ "min-height": "180px" }}
                      onClick={() =>
                        history.push("/myfinV2/library/viewedit-library")
                      }
                    >
                      <span>
                        <span className={commoncss.dFlexJustifysb}>
                          <span className={commoncss.dFlex}>
                            <MyFinIcon />
                            <span className="ml-2 modulecard-title truncate-2">
                              Template {i + 1}
                            </span>
                          </span>
                          <MenuDotIcon width={20} />
                        </span>
                        <span className={`${libcss.desc1} truncate-4 mt-3`}>
                          Lorem ipsum dolor sit amet consectetur Felis tellus
                          lacus risus neque viverra ipsum dolor sit amet
                          consectetur Felis tellus lacus risus neque see more
                        </span>
                      </span>
                      <span className={`${libcss.note1} mt-2`}>
                        <InfoIcon />
                        &ensp;Lorem ipsum dolor sit amet
                      </span>
                    </div>
                  ))} */}

                  {defaultLibraryList.map((obj, idx) => (
                    <div
                      className={`${libcss.libCard} clickable`}
                      style={{ "min-height": "180px", position: "relative" }}
                      onClick={() =>
                        history.push(
                          `/myfinV2/library/viewedit-library/${obj._id}`
                        )
                      }
                    >
                      <span>
                        <span className={commoncss.dFlexJustifysb}>
                          <span className={commoncss.dFlex}>
                            <MyFinIcon />
                            <span className="ml-2 modulecard-title truncate-2">
                              {obj.name}
                            </span>
                          </span>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenMenuId(obj._id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <MenuDotIcon width={20} />
                          </span>
                        </span>
                        <span className={`${libcss.desc1} truncate-4 mt-3`}>
                          {obj.description}
                        </span>
                      </span>
                      {openMenuId === obj._id && (
                        <div
                          ref={menuRef}
                          className={libcss.floatingMenu}
                          onMouseLeave={() => {
                            setTimeout(() => setOpenMenuId(null), 120);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            onClick={() => {
                              history.push(
                                `/myfinV2/library/viewedit-library/${obj._id}`
                              );
                            }}
                          >
                            View
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </motion.div>
              </div>
              <div className="mt-3">
                <span
                  className={`${commoncss.labelBlack} ${commoncss.fs19} ml-4`}
                >
                  Custom Templates
                </span>
                <motion.div
                  initial={{ y: 100, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: 0, opacity: 0 }}
                  transition={{ duration: 0.5, ease: "easeInOut" }}
                  className="modulecards-grid"
                >
                  {customLibraryList.map((obj) => (
                    <div
                      key={obj._id}
                      className={`${libcss.libCard} clickable`}
                      style={{ minHeight: "180px", position: "relative" }}
                      onClick={() =>
                        history.push(
                          `/myfinV2/library/viewedit-library/${obj._id}`
                        )
                      }
                    >
                      <span>
                        <span className={commoncss.dFlexJustifysb}>
                          <span className={commoncss.dFlex}>
                            <MyFinIcon />
                            <span className="ml-2 modulecard-title truncate-2">
                              {obj.name}
                            </span>
                          </span>

                          {/* Menu icon */}
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenMenuId(obj._id);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <MenuDotIcon width={20} />
                          </span>
                        </span>

                        <span className={`${libcss.desc1} truncate-4 mt-3`}>
                          {obj.description}
                        </span>
                      </span>

                      {/* Floating Menu */}
                      {openMenuId === obj._id && (
                        <div
                          ref={menuRef}
                          className={libcss.floatingMenu}
                          onMouseLeave={() => {
                            setTimeout(() => setOpenMenuId(null), 120);
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            onClick={() => {
                              console.log("View FS links", obj._id);
                            }}
                          >
                            View FS links
                          </div>
                          <div
                            onClick={() => {
                              console.log("Rename", obj._id);
                            }}
                          >
                            Rename
                          </div>
                          <div
                            onClick={() => {
                              console.log("Duplicate", obj._id);
                            }}
                          >
                            Duplicate
                          </div>
                          <div
                            // className={libcss.danger}
                            onClick={() => {
                              deleteGroupingTemplate(obj._id);
                            }}
                          >
                            Delete
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </motion.div>
              </div>
            </div>
          </motion.div>
        </div>
        {createCustomTemplateModal && (
          <CustomTemplateModal
            defaultLibraryList={defaultLibraryList}
            setCreateCustomTemplateModal={setCreateCustomTemplateModal}
            createCustTemplate={createCustTemplate}
          />
        )}
      </div>
    </>
  );
};

export default StandaloneLibrary;
